import { useContext } from "react";
import useLoading from "../../Hooks/useLoading";
import Loader from "../../Components/Shared/Loader";
import { UserDbContext } from "../../Contexts/UserDbContext";
import ByPass from "../../antd/pages/byPass";
import ShowConfidentialorByPass from "../../antd/components/confidentialTerm";

export default function CheckUser () {
    const { userDb } = useContext(UserDbContext);
    const { loading } = useLoading();

    return (
        <>
            {
                userDb ? (loading ? <Loader /> : <ShowConfidentialorByPass user={userDb} />) : <ByPass />
            }
        </>
    )
}

